import { AccountType, AccountContentKey } from 'js/types';

export enum ACCOUNT_NEXT_ACTION_VALUES {
  PURCHASE = 'Purchase',
  UPGRADE = 'Upgrade'
}

export const accountTypeContent: Record<AccountType, Partial<Record<AccountContentKey, string>>> = {
  FREE: {
    [AccountContentKey.ACCOUNT_NEXT_ACTION]: ACCOUNT_NEXT_ACTION_VALUES.PURCHASE,
    [AccountContentKey.NOUN_PROJECT_WARNING_MSG]: `To search the Noun Project's library of 5 million images you need a Core or Max plan. Purchase now to access this feature and more. \n\n During your free trial you can browse and use the 750,000 Noun Project images in the category folders to the left.`,
    [AccountContentKey.DURATION_LIMITS_PANEL_TOOLTIP]: `Purchase a Core or Max plan to increase your project duration limit`,
    [AccountContentKey.CUSTOM_FONT_WARNING_MSG]: `Personalize your project by uploading custom fonts and ensure your videos are always on brand. Purchase a Max subscription to access this feature and more.`,
    [AccountContentKey.PREVIEW_LINK_WARNING_MSG]: `Share a preview of your video with as many people as you like with a preview link. They don't need a VideoScribe account to view it. Purchase a Core or Max subscription to access this feature and more.`,
    [AccountContentKey.DOWNLOAD_UPSELL_MSG]: 'Remove the watermark from your download by purchasing a subscription.',
    [AccountContentKey.TIMELINE_TILE_PREMIUM_CONTENT_UPSELL_MSG]:
      'To download with this premium image, please purchase a Core or Max subscription.',
    [AccountContentKey.PREMIUM_CONTENT_UPSELL_MSG]:
      'To use premium content in your project, please purchase a Core or Max subscription. Access over 5 million images and icons. Purchase now to access this feature and more.',
    [AccountContentKey.PREMIUM_CONTENT_IMAGE_LIBRARY_UPSELL_MSG]:
      'To download with this premium image, please purchase a Core or Max subscription.'
  },
  LITE: {
    [AccountContentKey.ACCOUNT_NEXT_ACTION]: ACCOUNT_NEXT_ACTION_VALUES.UPGRADE,
    [AccountContentKey.NOUN_PROJECT_WARNING_MSG]: `To search the Noun Project's library of 5 million images you need a Core or Max plan. Upgrade to access this feature and more. \n\n With a Lite plan you can browse and use the 750,000 Noun Project images in the category folders to the left.`,
    [AccountContentKey.DURATION_LIMITS_PANEL_TOOLTIP]: `Upgrade to a Core or Max subscription to increase your project duration limit`,
    [AccountContentKey.CUSTOM_FONT_WARNING_MSG]: `Personalize your project by uploading custom fonts and ensure your videos are always on brand. Upgrade to a Max plan to access this feature and more.`,
    [AccountContentKey.PREVIEW_LINK_WARNING_MSG]: `Share a preview of your video with as many people as you like with a preview link. They don't need a VideoScribe account to view it. Upgrade to a Core or Max subscription to access this feature and more.`,
    [AccountContentKey.DOWNLOAD_UPSELL_MSG]:
      'Upgrade to a Core or Max plan now to get unlimited downloads for your projects.',
    [AccountContentKey.TIMELINE_TILE_PREMIUM_CONTENT_UPSELL_MSG]:
      'On your current subscription, this premium image will have a watermark, please upgrade to a Core or Max subscription to remove watermark.',
    [AccountContentKey.PREMIUM_CONTENT_UPSELL_MSG]:
      'To use premium content in your project, please upgrade to a Core or Max subscription. Access over 5 million images and icons. Upgrade now to access this feature and more.',
    [AccountContentKey.PREMIUM_CONTENT_IMAGE_LIBRARY_UPSELL_MSG]: `On your current subscription, this premium image will have a watermark, please upgrade to a Core or Max subscription to remove watermark.`
  },
  PLUS: {
    [AccountContentKey.ACCOUNT_NEXT_ACTION]: ACCOUNT_NEXT_ACTION_VALUES.UPGRADE,
    [AccountContentKey.DURATION_LIMITS_PANEL_TOOLTIP]: `Upgrade to a Max subscription to increase your project duration limit`
  },
  PRO: {
    [AccountContentKey.ACCOUNT_NEXT_ACTION]: ACCOUNT_NEXT_ACTION_VALUES.UPGRADE,
    [AccountContentKey.DURATION_LIMITS_PANEL_TOOLTIP]: `Upgrade to a Max subscription to increase your project duration limit`
  },
  EDU: {},
  CORE: {
    [AccountContentKey.ACCOUNT_NEXT_ACTION]: ACCOUNT_NEXT_ACTION_VALUES.UPGRADE,
    [AccountContentKey.CUSTOM_FONT_WARNING_MSG]: `Personalize your project by uploading custom fonts and ensure your videos are always on brand. Upgrade to a Max plan to access this feature and more.`,
    [AccountContentKey.DURATION_LIMITS_PANEL_TOOLTIP]: `Upgrade to a Max subscription to increase your project duration limit`
  },
  MAX: {}
};

const mapAccountTypeContentKeyToContent = (accountType: AccountType, contentKey: AccountContentKey) => {
  return accountTypeContent[accountType][contentKey] ?? '';
};

export default mapAccountTypeContentKeyToContent;
